import { StoreLink } from "@bluframe/mightychroma-mightytool-frontend-types"
import store from "mocks/vendors/store"

const storeLink: StoreLink = {
  createdAt: "2024-02-12T12:00:00.000Z",
  currencyCode: "USD",
  currencySymbol: "$",
  id: "64eb10ab-9d29-4f73-ba9c-4fb6028ca8b1",
  isInStock: true,
  isPreOrder: false,
  isPublished: true,
  priceAmount: 2799,
  priceFormatted: "27.99",
  publishedAt: "2024-02-12T12:00:00.000Z",
  store,
  updatedAt: "2024-02-12T12:00:00.000Z",
  url: "https://vinegarsyndrome.com/collections/frontpage-partner-labels/products/dandelion"
}

export const storeLinkPreOrder: StoreLink = {
  ...storeLink,
  isPreOrder: true
}

export default storeLink
